import { crv, css, cva } from '@/styled-system/css';
import type { SystemStyleObject } from '@/styled-system/types';

const defaultSizeStyles = css.raw({
  blockSize: 'auto',
  borderRadius: 'obj.soft',
});

const sizeVariants = crv('size', {
  xs: {
    ...defaultSizeStyles,
    maxInlineSize: '360px',
  },
  sm: {
    ...defaultSizeStyles,
    maxInlineSize: '540px',
  },
  md: {
    ...defaultSizeStyles,
    maxInlineSize: '720px',
  },
  lg: {
    ...defaultSizeStyles,
    maxInlineSize: '900px',
  },
  xl: {
    ...defaultSizeStyles,
    maxInlineSize: '1080px',
  },
  fullScreen: {
    blockSize: '100%',
    borderRadius: 'obj.fullWidth',
    maxInlineSize: '100%',
  },
});

export const modalContentRecipe: {
  (props?: any): string;
  raw: (props?: any) => SystemStyleObject;
} = cva({
  base: {
    'display': 'flex',
    'flexDirection': 'column',
    'backgroundColor': 'bg.elevated.sheet',
    'boxShadow': 'lg',
    'position': 'relative',
    'blockSize': 'auto',
    'inlineSize': '100%',
    'minBlockSize': '0',
    // TODO: use animation tokens when available
    'animation': 'zoom-in 0.2s ease-out',
    'zIndex': 2,

    '&:not(:has([data-c11n-component="Modal.Header"]))': {
      paddingBlockStart: 'layout.loosest',
    },
  },
  variants: {
    scrollDocument: {
      true: {},
      false: {
        maxBlockSize: '100%',
      },
    },
    ...sizeVariants,
  },
});
